'use client';

import { Breakpoints, useMediaQuery } from '@/app_lib/hooks/useMediaQuery';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';
import type { VariantProps } from '@/main/lib/providers/OptimizelyProvider';

export interface RelatedVideoEmbedProps {
  /** Default content (desktop and mobile when vertical_video_scrolling flag is off) */
  defaultContent: React.ReactNode;
  /** Mobile content when vertical_video_scrolling flag is enabled */
  mobileContentWithVertical: React.ReactNode;
}

/** Client component that renders content based on viewport and Optimizely flag. */
// biome-ignore lint/style/useNamingConvention: React component
export function RelatedVideoEmbed({ defaultContent, mobileContentWithVertical }: RelatedVideoEmbedProps) {
  const isMobile = useMediaQuery(Breakpoints.Mobile) ?? false;
  const { userFlags } = useOptimizely();
  const verticalVideoEnabled = (userFlags.vertical_video_scrolling as VariantProps | undefined)?.enabled ?? false;
  const useVerticalPlayer = isMobile && verticalVideoEnabled;

  return useVerticalPlayer ? mobileContentWithVertical : defaultContent;
}
